import { createFileRoute } from '@tanstack/react-router'
import { MentionFeed } from '@/components/social-listening/mention-feed'

export const Route = createFileRoute('/_app/social-listening/')({
  component: MentionsPage,
})

function MentionsPage() {
  return <MentionFeed />
}
